import { render } from "./NewJoinReport.vue?vue&type=template&id=53a230da"
import script from "./NewJoinReport.vue?vue&type=script&lang=js"
export * from "./NewJoinReport.vue?vue&type=script&lang=js"

import exportComponent from "D:\\VueProject\\Cigl-Vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__